import { useAppSelector } from '@hooks';
import { useCategory } from '@hooks/category/category.hook';
import { Stack } from '@mui/material';
import { CategoryFilter } from '../CategoryFilters/CategoryFilters';

export const DrawerCategoryFilters = () => {
  const { handleFilterChange } = useCategory();

  const allFilters = useAppSelector((state) => state.catalog.filters)?.filter((filterItem) => {
    const hasAtLeastOneOption = filterItem?.facets?.filter((x) => x.name && x.key).length;
    return (filterItem?.groupFieldName || filterItem?.groupName) && hasAtLeastOneOption;
  });

  const handleChange = ({ fieldName = '', fieldValue = '', fieldLabel = '' }) => {
    if (typeof handleFilterChange === 'function') {
      handleFilterChange({ fieldName, fieldValue, fieldLabel });
    }
  };
  return (
    <Stack spacing={4} mt={4} px={2}>
      {allFilters?.map((filter, key) => (
        <CategoryFilter
          key={filter.groupFieldName + '-' + key}
          filter={filter}
          onChange={handleChange}
          dropdownZIndex={1200}
        />
      ))}
    </Stack>
  );
};
